import {PageFragment} from "../../shared/PageFragment";
import React from "react";
import {PlaceholderFragment} from "../../shared/PlaceholderFragment";

export class DirectoryFragment extends PageFragment {

  renderContent(): React.ReactElement {
    return <PlaceholderFragment />;
  }
}